import { defaultContactAdditionalState } from './module-contactadditional-state';

export default {
	resetState(state) {
		Object.assign(state, defaultContactAdditionalState);
	},
	updateContactAdditionalList: function(state, res) {
		state.ContactAdditionalData.removeAll();
		state.ContactAdditionalData.append(res.Data);
		state.Total = res.Total;
	}
};
